import __C from '../../../../../../includes/primitives/_constant_'

export default {
    Canvas: {
      CanvasWidth: 600,
      CanvasHeight: 180,
      CanvasBorderWeight: 0.1,
      CanvasBorderColor: '#bcbcbc',
      CanvasFillColor: 'Transparent',
      CanvasOpacity: 0.2,

      CanvasChartX: 0,
      CanvasChartY: 0,
      CanvasChartWidth: 260,
      CanvasChartHeight: 310,
      CanvasChartBorderWeight: 0,
      CanvasChartBorderColor: '#757575',
      CanvasChartFillColor: '#757575',
      CanvasChartOpacity: 0,
      CanvasChartSpace: 0,

      CanvasFontFamily: 'roboto',
    },
    Text: {
      Text: [
        { text: 'Support Fabrication', x:20, y: -20, font: 'roboto', class: 'regular', size: 12, color: '#424242', align: 'start' },
      ],
      Filter: [
        { name: 'MOD'   , x: -50, y: -20, font: 'roboto', class: 'regular', size: 12, color: '#313131', align: 'start' },
      ],
      Sql: [
        {
          query: "SELECT 'PBF COMPESSOR AIR COOLER - TRAIN 4' TITLE", 
          text: 'Data Source',
          x: -30,
          y: -20,
          font: 'roboto',
          style: 'regular',
          size: 11,
          color: '#44A9DF',
          align: 'start'
        },
      ]
    },
    Queries: {
      // SQL1: [
      //   {ORIGINATING_COMPANY:"E2 - Sinopec Engineering Incorporation",ISSUED:124,RESPONDED:104,OPEN:15,CANCELLED:5},
      //   {ORIGINATING_COMPANY:"EM - ExxonMobil Chemical",ISSUED:230,RESPONDED:179,OPEN:46,CANCELLED:5},
      //   {ORIGINATING_COMPANY:"Total",ISSUED:354,RESPONDED:283,OPEN:61,CANCELLED:10}
      // ],
    },
    DataItems:    [
      {ITEM:"CAR",TOTAL_ISSUE:2,TOTAL_CLOSED:1,ISSUED_THISWK:0,TOTAL_OPEN:1,CLOSED_RATE:50},
      {ITEM:"NCR",TOTAL_ISSUE:76,TOTAL_CLOSED:72,ISSUED_THISWK:0,TOTAL_OPEN:4,CLOSED_RATE:94.7},
      {ITEM:"QSN",TOTAL_ISSUE:21,TOTAL_CLOSED:13,ISSUED_THISWK:2,TOTAL_OPEN:8,CLOSED_RATE:61.9},
      {ITEM:"SN-A",TOTAL_ISSUE:77,TOTAL_CLOSED:67,ISSUED_THISWK:3,TOTAL_OPEN:10,CLOSED_RATE:87},
      {ITEM:"SN-B",TOTAL_ISSUE:99,TOTAL_CLOSED:94,ISSUED_THISWK:2,TOTAL_OPEN:5,CLOSED_RATE:94.9}
    ],
}